<template>
    <v-footer class="mt-n0 blue darken-5">
        <v-card class="flex blue darken-5" flat tile>
            <v-card-title> </v-card-title>
            <v-row no-gutters class="text-left justify-center">
                <v-col class="pb-6" cols="12" sm="12" md="2" xl="2">
                    <v-row id="column">
                        <ul class="footerList">
                            <li v-for="item in column1" :key="item.text">
                                <a :href="item.link">
                                    <v-icon dark class="pr-2">{{
                                        item.icon
                                    }}</v-icon
                                    >{{ item.text }}</a
                                >
                            </li>
                        </ul>
                    </v-row>
                </v-col>
                <v-col class="pb-6" cols="12" sm="12" md="2">
                    <v-row id="column">
                        <ul class="footerList">
                            <li v-for="item in column2" :key="item.text">
                                <a :href="item.link">
                                    <v-icon dark class="pr-2">{{
                                        item.icon
                                    }}</v-icon
                                    >{{ item.text }}</a
                                >
                            </li>
                        </ul>
                    </v-row>
                </v-col>
                <v-col class="pb-6" cols="12" sm="12" md="2">
                    <v-row id="column">
                        <ul class="footerList">
                            <li v-for="item in column3" :key="item.text">
                                <a :href="item.link">
                                    <v-icon dark class="pr-2">{{
                                        item.icon
                                    }}</v-icon
                                    >{{ item.text }}</a
                                >
                            </li>
                        </ul>
                    </v-row>
                </v-col>
                <v-col class="pb-3" cols="12" sm="12" md="2">
                    <v-row id="column">
                        <ul class="footerList">
                            <li v-for="item in column4" :key="item.text">
                                <a :href="item.link">
                                    <v-icon dark class="pr-2">{{
                                        item.icon
                                    }}</v-icon
                                    >{{ item.text }}</a
                                >
                            </li>
                        </ul>
                    </v-row>
                    <v-spacer></v-spacer>
                </v-col>
            </v-row>
            <v-row no-gutters class="text-center justify-center">
                <v-col cols="12" sm="12" md="2" xl="2" class="pa-0 text-center">
                    <v-flex
                        :class="{
                            'ma-0 mr-4 pa-0': $vuetify.breakpoint.smAndDown,
                            'text-start mt-3 ml-n12 text-end':
                                $vuetify.breakpoint.mdAndUp
                        }"
                    >
                        <img
                            :src="'/images/' + 'ans_as_logo_white.svg'"
                            alt="logo Akademii Nauk Stosowanych Angelusa Silesiusa"
                            :width="200"
                            :height="150"
                        />
                    </v-flex>
                </v-col>
                <v-col
                    :class="{
                        'ma-2 mr-4 pa-2 bg-white-line':
                            $vuetify.breakpoint.smAndDown,
                        'ml-n16 bg-white-line': $vuetify.breakpoint.mdAndUp
                    }"
                    cols="12"
                    sm="12"
                    md="3"
                    xl="3"
                >
                </v-col>

                <v-col cols="12" sm="12" md="2" xl="2" class="pa-0 text-center">
                    <v-flex
                        :class="{
                            'pa-0 ml-8': $vuetify.breakpoint.smAndDown,
                            'mt-10 ml-n2 d-flex': $vuetify.breakpoint.mdAndUp
                        }"
                    >
                        <v-img
                            style="  text-align-last: center;"
                            transition="scale-transition"
                            lazy-src="/images/images/PUAS_www_ksztalcimy-praktycznie-white.svg"
                            :max-height="80"
                            :max-width="360"
                            :src="
                                '/images/' +
                                    'PUAS_www_ksztalcimy-praktycznie-white.svg'
                            "
                            alt="Banner Kształcimy praktycznie"
                        ></v-img>
                    </v-flex>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="3"
                    xl="3"
                    :class="{
                        'ma-2 pa-2': $vuetify.breakpoint.smAndDown,
                        'mt-6 ml-n4 bg-white-line': $vuetify.breakpoint.mdAndUp
                    }"
                >
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="2"
                    xl="2"
                    :class="{
                        'ma-2 pa-2': $vuetify.breakpoint.smAndDown,
                        'mt-6 ml-n4 bg-white-line': $vuetify.breakpoint.mdAndUp
                    }"
                >
                </v-col>
            </v-row>
        </v-card>
    </v-footer>

</template>

<script>
export default {
    data: () => ({
        column1: [
            {
                icon: "mdi-chevron-right",
                text: "Uczelnia ",
                link: "/uczelnia"
            },

            {
                icon: "mdi-chevron-right",
                text: "Fundusze europejskie",
                link: "/fundusze-europejskie"
            },

            {
                icon: "mdi-chevron-right",
                text: "Współpraca z otoczeniem",
                link: "/wspolpraca-z-otoczeniem-spoleczno-gospodarczym"
            },
            {
                icon: "mdi-chevron-right",
                text: "Kontakt",
                link: "/kontakt"
            }
        ],
        column2: [
            {
                icon: "mdi-chevron-right",
                text: "Dla kandydata",
                link: "kandydat"
            },
            {
                icon: "mdi-chevron-right",
                text: "Dla studenta",
                link: "/student"
            },
            {
                icon: "mdi-chevron-right",
                text: "Erasmus +",
                link: "/erasmus"
            },
            {
                icon: "mdi-chevron-right",
                text: "Biblioteka Uczelniana",
                link: "/biblioteka-uczelniana"
            }
        ],

        column3: [
            {
                icon: "mdi-chevron-right",
                text: "Deklaracja dostępności",
                link: "/deklaracja-dostepnosci"
            },
            {
                icon: "mdi-chevron-right",
                text: "Polityka prywatności",
                link: "/polityka-prywatnosci"
            },
            {
                icon: "mdi-chevron-right",
                text: "Biuletyn Informacji Publicznej",
                link: "https://bip.ans.edu.pl/"
            },
            {
                icon: "mdi-chevron-right",
                text: "Mapa strony",
                link: "/mapa-strony"
            }
        ],
        column4: [
            {
                icon: "mdi-chevron-right",
                text: "Instytut Przyrodniczo-Techniczny",
                link: "/student/instytuty/instytut-przyrodniczo-techniczny"
            },
            {
                icon: "mdi-chevron-right",
                text: "Instytut Społeczno-Prawny",
                link: "/student/instytuty/instytut-spoleczno-prawny"
            },
            {
                icon: "mdi-chevron-right",
                text: "Instytut Zdrowia",
                link: "/student/instytuty/instytut-zdrowia"
            },
            {
                icon: "mdi-chevron-right",
                text: "Dział Praktyk Studenckich i Karier",
                link: "/dzial-praktyk-studenckich-i-karier"
            }
        ]
    })
};
</script>

<style scoped>
#column {
    min-width: 300px;
}
.bg-white-line {
    background-image: url("/images/header-white-line.png");
    background-repeat: repeat-x;
    display: inline-block;
}

ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

li a {
    display: block;
    color: white;
    text-align: left;
    padding: 10px 6px;
    text-decoration: none;
}

li a:hover {
    background-color: #11254a;
}
</style>
